export type LifePointType = 'resistance' | 'force' | 'flexibility' | 'mind';

export const HumanLifePoints = {
  ['resistance']: 'Resistencia',
  ['force']: 'Fuerza',
  ['flexibility']: 'Flexibilidad',
  ['mind']: 'Mente',
};
